module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body reports-admin-panel"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "data": _vm.reportStatus,
      "height": "655",
      "stripe": "",
      "id": "assoc-table"
    }
  }, [_c('el-table-column', {
    staticClass: "text-center",
    attrs: {
      "label": "Report Date",
      "width": "100",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n                                " + _vm._s(props.row.date) + "\n                                ")]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.biddersList), function(bidder, index) {
    return _c('el-table-column', {
      staticClass: "text-center",
      attrs: {
        "label": bidder,
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [(props.row.data.filter(function (x) { return x['report_name'] == bidder; }).length > 0) ? _c('div', [(props.row.data.filter(function (x) { return x['report_name'] == bidder; })[0].is_done) ? _c('div', {
            class: 'text-center index' + index
          }, [_c('el-button', {
            key: bidder.replace(' ', '_') + '-' + props.row.date,
            class: 'is-circle btn-' + bidder.replace(' ', '_') + '-' + props.row.date,
            attrs: {
              "type": "success",
              "icon": "el-icon-check"
            },
            on: {
              "click": function($event) {
                return _vm.regenerateReport(bidder, props.row.date, $event)
              }
            }
          })], 1) : _c('div', {
            staticClass: "text-center"
          }, [_c('el-button', {
            key: bidder.replace(' ', '_') + '-' + props.row.date,
            class: 'is-circle btn-' + bidder.replace(' ', '_') + '-' + props.row.date,
            attrs: {
              "type": "danger",
              "icon": "el-icon-close"
            },
            on: {
              "click": function($event) {
                return _vm.regenerateReport(bidder, props.row.date, $event)
              }
            }
          })], 1)]) : _c('div', {
            staticClass: "text-center"
          }, [_c('el-button', {
            key: bidder.replace(' ', '_') + '-' + props.row.date,
            class: 'is-circle btn-' + bidder.replace(' ', '_') + '-' + props.row.date,
            attrs: {
              "type": "danger",
              "icon": "el-icon-close"
            },
            on: {
              "click": function($event) {
                return _vm.regenerateReport(bidder, props.row.date, $event)
              }
            }
          })], 1), _vm._v(" "), _c('div', {
            class: 'text-center white-space-pre atd-text-' +
              bidder.replace(' ', '_') +
              '-' +
              props.row.date
          }, [(props.row.data.filter(function (x) { return x['report_name'] == bidder; }).length > 0) ? _c('div', [_vm._v("\n                                        " + _vm._s(_vm._f("moment")(_vm.getLastUpdateDate(
            props.row.data.filter(function (x) { return x['report_name'] == bidder; })[0]
          ), 'MMM Do YYYY[\n] h:mm:ss a')) + "\n                                    ")]) : _vm._e()])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Update Pub Dashboard",
      "width": "110",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('el-button', {
          class: 'is-circle btn-resync text-center',
          attrs: {
            "type": "primary",
            "icon": "el-icon-refresh"
          },
          on: {
            "click": function($event) {
              return _vm.confirmReUpload(props.row.date)
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Download",
      "width": "110",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          },
          on: {
            "command": function (command) { return _vm.handleCommand(command, props.row.date); }
          }
        }, [_c('el-button', {
          staticClass: "el-dropdown-link",
          attrs: {
            "size": "mini",
            "round": ""
          }
        }, [_vm._v(" Download ")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "icon": "el-icon-plus",
            "command": "get_bidder_revenue_report"
          }
        }, [_vm._v("Bidder Report")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "icon": "el-icon-circle-plus",
            "command": "get_dfp_bidder_revenue_report"
          }
        }, [_vm._v("DFP + Bidder Report")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "icon": "el-icon-circle-plus-outline",
            "command": "get_axt_report"
          }
        }, [_vm._v("AXT Report")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "icon": "el-icon-circle-plus-outline",
            "command": "get_amp_report"
          }
        }, [_vm._v("AMP Report")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "icon": "el-icon-circle-plus-outline",
            "command": "get_adserving_fee"
          }
        }, [_vm._v("Adserving Fee Report")])], 1)], 1)]
      }
    }])
  })], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "report-upload-popup",
    attrs: {
      "visible": _vm.UploadScreenVisible,
      "before-close": _vm.clearFilesList
    },
    on: {
      "update:visible": function($event) {
        _vm.UploadScreenVisible = $event
      }
    }
  }, [_c('span', {
    staticClass: "el-dialog__title text-center"
  }, [_vm._v("Upload " + _vm._s(_vm.bidder_name) + " report for " + _vm._s(_vm.report_date))]), _vm._v(" "), (_vm.bidder_name == 'mmadx') ? [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "m-r-15"
  }, [_c('h5', {
    staticClass: "dis-inline-block"
  }, [_vm._v("Report type:")])]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.reportType),
      callback: function($$v) {
        _vm.reportType = $$v
      },
      expression: "reportType"
    }
  }, _vm._l((_vm.reportOptions), function(item) {
    return _c('el-option', {
      key: item.reportType,
      attrs: {
        "label": item.label,
        "value": item.reportType
      }
    })
  }), 1)], 1)] : _vm._e(), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    ref: "upload",
    staticClass: "upload-demo m-t-20",
    attrs: {
      "drag": "",
      "limit": 1,
      "action": "reports/v1/upload/",
      "auto-upload": false,
      "http-request": _vm.upload,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.fileList
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])]), _vm._v(" "), (_vm.bidder_name == 'updated') ? _c('div', {
    staticClass: "el-upload__text",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n                                Upload modified DFP + Bidder Report\n                            ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelUploadAction
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Upload Report")])], 1)], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalPage,
      "page-size": 5
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border heading-cart"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Admin Reports")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43fc7308!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/reports/ReportsAdmin.vue
// module id = 679
// module chunks = 2